import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const CustomDropDownMultipleAutoComplete = ({ items, selectedName = [], setSelectedName,placeholder, width = '250px' }) => {
    const handleChange = (values) => {
        setSelectedName(values);
    };

    return (
        <Select
            style={{ width: width }}
            mode="multiple"
            value={selectedName}
            onChange={handleChange}
            placeholder={placeholder}
        >
            {items.map(item => (
                <Option key={item.label} value={item.label}>
                    {item.label}
                </Option>
            ))}
        </Select>
    );
};

export default CustomDropDownMultipleAutoComplete;
